// extracted by mini-css-extract-plugin
export default {"container":"ConfirmPopup_container__9Ibop","text":"ConfirmPopup_text__RWwRz","buttonsRemoveBlock":"ConfirmPopup_buttonsRemoveBlock__WU75G"};